import React, { FC } from 'react';

import { IconProps } from 'types/components';

import Icon from './Icon';

const ArrowDown: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path d="M12 20a1 1 0 0 1-1-1V5a1 1 0 0 1 2 0v14a1 1 0 0 1-1 1Z" />
    <path d="M12 20a1 1 0 0 1-.71-.29 1 1 0 0 1 0-1.42l6-6a1 1 0 0 1 1.42 1.42l-6 6A1 1 0 0 1 12 20Z" />
    <path d="M12 20a1 1 0 0 1-.71-.29l-6-6a1 1 0 0 1 1.42-1.42l6 6a1 1 0 0 1 0 1.42A1 1 0 0 1 12 20Z" />
  </Icon>
);

export default ArrowDown;
